/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

"use client";

import { CosmosText, GeminiCard } from "@cosmos/components";

import { css, cx } from "@panda/css";
import { Grid, VStack } from "@panda/jsx";

import type { SearchSectionProps } from "./Search.section";

type SearchNoResultsProps = Pick<SearchSectionProps, "searchValue" | "noResultsLabel" | "suggestedLinks">;

const Layout_4cards: string = css({
	gridTemplateColumns: "repeat(4, 1fr)",
	lgDown: { gridTemplateColumns: "repeat(2, 1fr)" },
	smDown: { gridTemplateColumns: "1fr" },
});

export const SearchNoResults = ({
	searchValue,
	noResultsLabel,
	suggestedLinks,
}: SearchNoResultsProps): React.JSX.Element => {
	return (
		<VStack
			gap="eds.dimension.40"
			paddingBlockStart="eds.dimension.40"
			borderBlockStart="1px solid token(colors.eds.palette.transparent.light.005)"
			width="full"
		>
			<CosmosText variant="headingXL">
				{noResultsLabel} “{searchValue}”{" "}
			</CosmosText>
			<Grid className={cx("gemini-cards", Layout_4cards)} gap="eds.dimension.32" width="full">
				{suggestedLinks.map((suggestedLink, i) => (
					<GeminiCard key={`suggested-link-${i}`} animate={false} {...suggestedLink} />
				))}
			</Grid>
		</VStack>
	);
};
